import { render, staticRenderFns } from "./NavDropdown.vue?vue&type=template&id=2523af49&"
import script from "./NavDropdown.vue?vue&type=script&lang=js&"
export * from "./NavDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports